import React from 'react'
import Page from "../../components/Page";
import CertificationDetailsSection from "../../components/Certification/CertificationDetailsSection"

export default function CertificationDetailsPage() {
  return (
    <Page>
        <CertificationDetailsSection />
    </Page>
  )
}
